import React from 'react';
import classNames from 'classnames';

export interface AlertTextProps {
  children?: React.ReactNode | string;
  className?: string;
  id?: string;
}

const AlertText = ({ children, className, id }: AlertTextProps): JSX.Element => {
  const alertClasses = classNames(className, 'usa-alert__text');
  return (
    <p id={id} className={alertClasses}>
      {children}
    </p>
  );
};

export default AlertText;
